<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Voorlopige aanslagen {{ this.year }}
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een voorlopige aanslag is een bericht van de Belastingdienst waarin staat hoeveel belasting je moet
                betalen of terugkrijgt. Dit bedrag is gebaseerd op een voorlopige berekening. Later volgt altijd een
                definitieve berekening.

                In het scherm 'Voorlopige aanslagen ib/zvw' geef je het bedrag aan dat je al over {{ this.year }} hebt
                betaald of ontvangen via:
                <li class="list">een voorlopige aanslag inkomstenbelasting en premie volksverzekeringen</li>
                <li class="list">een voorlopige aanslag inkomensafhankelijke bijdrage Zorgverzekeringswet</li>
                De bedragen die je invult zijn nodig voor een juiste voorlopige berekening van je inkomstenbelasting en
                premie volksverzekeringen. Je vindt dit in het onderdeel 'Berekeningen'.
                <div class="space10"></div>

                De Belastingdienst houdt bij het vaststellen van de definitieve aanslag rekening met het bedrag dat je
                al hebt betaald of teruggekregen op grond van een voorlopige aanslag.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Om welke teruggekregen bedragen en vergoedingen gaat het
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat om teruggekregen bedragen en vergoedingen voor:
                <li class="list">partneralimentatie en andere onderhoudsverplichtingen</li>
                <li class="list">zorgkosten</li>
                <li class="list">een gift die onder een ontbindende voorwaarde is gedaan, en die ontbonden of herroepen
                    is. Het gaat om een gift die je in een eerdere aangifte hebt afgetrokken.
                </li>
                <li class="list">studiekosten en andere scholingsuitgaven die je sinds 2001 hebt afgetrokken</li>
            </div>
        </div>
    </div>

</div>



